/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';

const useInitLoading = ({ timeout = 0, hasData = false, }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (hasData && !loaded) {
      setTimeout(() => setLoaded(true), timeout);
    } else if (!hasData && loaded) {
      setLoaded(false);
    }
  }, [hasData]);

  return { loaded };
};

export default useInitLoading;
